import { Component, Input, OnInit } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'iv-loading',
  templateUrl: './iv-loading.component.html',
  styleUrls: ['./iv-loading.component.scss']
})
export class IvLoadingComponent implements OnInit {
  @Input() hidden: boolean;
  @Input() color: string;
  @Input() diameter: number = 68;
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() strokeWidth: number = 8;
  @Input() value: number = 33;
  @Input() text: string;
  @Input() fullScreen: boolean = true;

  ngOnInit() {
    let style = document.createElement('style');
    style.innerHTML = 'iv-loading .mat-progress-spinner circle, iv-loading .mat-spinner circle {stroke: '+this.color+'}';
    document.body.appendChild(style);
  }
}
